import { useTranslation } from 'react-i18next';
import AddGroupModal from '../modals/code-based/add-group/AddGroupModal';
import ModalContext from '../../../contexts/ModalContext';
import { useContext } from 'react';

import Button from '@pelckmans/elementis/components/button';
import PlusIcon from '@pelckmans/elementis/icons/plus';
import useGroups from '../hooks/useGroups';

export default function AddGroupButtonVO() {
  const { t } = useTranslation();
  const { showModal } = useContext(ModalContext);
  const { selectedSchoolYear, fetchGroups } = useGroups();

  if (!selectedSchoolYear || selectedSchoolYear?.hasPassed) return null;

  return (
    <Button
      prominence="secondary"
      size="sm"
      startIcon={<PlusIcon />}
      onClick={() =>
        showModal(
          <AddGroupModal
            id="add-code-based-group-modal"
            selectedSchoolYear={selectedSchoolYear}
            onGroupAdded={() => fetchGroups(selectedSchoolYear)}
          />,
        )
      }
    >
      {t('PAGES.MY_GROUPS.ADD_GROUP.BUTTON_DROPDOWN.TITLE')}
    </Button>
  );
}
